// const API_DOMAIN = "https://qaaccountsetup.xemplarinsights.com";
// const API_DOMAIN = "https://sw-fleetdrive-personal-qa.xemplarinsights.com";
const API_DOMAIN = "https://personaldrive.smartwheelsgps.com";

document.addEventListener("DOMContentLoaded", () => {
  const card = document.querySelector(".signup-card");
  const slides = document.querySelectorAll(".step-slide");
  const createAccountBtn = document.getElementById("createAccountBtn");
  const prevStepBtn = document.getElementById("prevStepBtn");
  const nextStep2Btn = document.querySelector(
    "#step-2 .btn.btn-primary.w-50:last-child",
  );
  const prevStep3Btn = document.getElementById("prevStep3Btn");

  const firstNameInput = document.getElementById("firstName");
  const lastNameInput = document.getElementById("lastName");
  const accountNameInput = document.getElementById("accountName");
  const ownerDriverToggle = document.getElementById("ownerDriverToggle");
  const emailField = document.getElementById("emailField");
  const driverFirstName = document.getElementById("driverFirstName");
  const driverLastName = document.getElementById("driverLastName");

  const passwordInput = document.getElementById("password");
  const confirmPasswordInput = document.getElementById("confirmPassword");
  const passwordError = document.getElementById("passwordError");
  const confirmPasswordError = document.getElementById("confirmPasswordError");

  const driverPasswordInput = document.getElementById("driverPassword");
  const driverConfirmPasswordInput = document.getElementById(
    "driverConfirmPassword",
  );
  const driverPasswordError = document.getElementById("driverPasswordError");
  const driverConfirmPasswordError = document.getElementById(
    "driverConfirmPasswordError",
  );

  const emailInput = document.getElementById("signupEmail");
  const emailMsg = document.getElementById("emailValidationMsg");
  const agreeCheckbox = document.getElementById("agreeCheckbox");

  const zipInput = document.getElementById("zipCode");
  const stateSelect = document.getElementById("stateSelect");
  const countrySelect = document.getElementById("countrySelect");
  const referralSelect = document.getElementById("referralSourceSelect");
  const subscriptionPriceEls = document.querySelectorAll(
    '[id="subscriptionPrice"]',
  );
  const step2AgreeCheckbox = document.querySelector(
    '#step-2 .form-check-input[type="checkbox"]',
  );
  let defaultSubscriptionPrice = "";
  const countyInput = document.getElementById("county");
  const finalSubmitBtn = document.getElementById("finalSubmitBtn");
  const confirmBillingBtn = document.getElementById("confirmBillingBtn");
  const driverDob = document.getElementById("driverDob");
  const driverGender = document.getElementById("driverGender");
  const driverEmailInput = document.getElementById("driverEmailInput");
  const driverEmailMsg = document.getElementById("driverEmailValidationMsg");

  // Set max date for Driver DOB (must be at least 13 years old)
  if (driverDob) {
    const today = new Date();
    const minAgeDate = new Date(
      today.getFullYear() - 13,
      today.getMonth(),
      today.getDate(),
    );
    const maxDateStr = minAgeDate.toISOString().split("T")[0];
    driverDob.setAttribute("max", maxDateStr);
  }

  // Show All Features Button Logic
  const showAllBtn = document.getElementById("showAllFeaturesBtn");
  if (showAllBtn) {
    let isExpanded = false;
    showAllBtn.addEventListener("click", () => {
      const toggleItems = document.querySelectorAll(".toggleable-feature");
      isExpanded = !isExpanded;

      toggleItems.forEach((item) => {
        if (isExpanded) {
          item.classList.remove("mobile-hidden");
          item.classList.remove("animate-hide");
          item.classList.add("animate-reveal");
        } else {
          item.classList.remove("animate-reveal");
          item.classList.add("animate-hide");
        }
      });

      if (!isExpanded) {
        setTimeout(() => {
          if (!isExpanded) {
            toggleItems.forEach((item) => {
              item.classList.add("mobile-hidden");
              item.classList.remove("animate-hide");
            });
          }
        }, 500);
      }

      // Update Button Text and Icon
      if (isExpanded) {
        showAllBtn.innerHTML = `
          Hide 
          <svg style="transform: rotate(180deg); transition: transform 0.3s;" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L9 1" stroke="#7A5CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
      } else {
        showAllBtn.innerHTML = `
          See all 
          <svg style="transition: transform 0.3s;" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L9 1" stroke="#7A5CFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
      }
    });
  }

  const updateSubscriptionPrice = (price) => {
    subscriptionPriceEls.forEach((el) => {
      el.textContent = price;
    });
  };

  // --- Payment Callback Logic  ---
  const handlePaymentCallback = async () => {
    const params = new URLSearchParams(window.location.search);
    // Legacy support: sometimes URL is ...?key=value, sometimes params might be parsed differently.
    // Using URLSearchParams is standard.
    // Check for both camelCase (standard) and uppercase 'ID' (observed in callback)
    const thirdPartyCallId =
      params.get("thirdPartyCallId") || params.get("thirdPartyCallID");

    // Redirect to homepage if visiting success page directly without parameter
    if (
      window.location.pathname.includes("drive-signup-success") &&
      !thirdPartyCallId
    ) {
      window.location.href = "/";
      return;
    }

    if (!thirdPartyCallId) return;

    console.log("Processing Payment Callback:", thirdPartyCallId);

    // Replace Card Content with Loader
    const signupCard = document.querySelector(".signup-card");
    if (signupCard) {
      signupCard.innerHTML = `
        <div style="text-align: center; padding: 40px;">
          <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;"></div>
          <h4 class="mt-4">Finalizing Account Setup...</h4>
          <p class="text-muted">Please wait while we confirm your payment.</p>
        </div>
      `;
    }

    try {
      // 1. Get Transaction Details
      const txnResponse = await fetch(
        `${API_DOMAIN}/telematics/service/dashboard/get-transaction-details`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ thirdPartyCallId }),
        },
      );
      const txnData = await txnResponse.json();

      if (
        txnData.success == 1 &&
        txnData.txn_details &&
        txnData.txn_details.length > 0
      ) {
        const txn = txnData.txn_details[0];
        const storedUser = JSON.parse(localStorage.getItem("userDetails"));

        if (!storedUser) {
          throw new Error("Session expired. Please restart the registration.");
        }

        const finalPayload = {
          ...storedUser,
          setup_datetime: new Date().toISOString(), // Update timestamp
          user_name: txn.user_name,
          txn_date: txn.txn_date,
          transaction_id: txn.transaction_id,
          policy_payment_request_id: txn.policy_payment_request_id,
          payment_status: txn.payment_status,
          payment_method: txn.payment_method,
          payment_buffer_message: txn.payment_buffer_message,
          add_to_vault: txn.add_to_vault,
          customer_uuid: txn.payment_token,
        };

        if (!finalPayload.dob && finalPayload.driver_dob) {
          finalPayload.dob = finalPayload.driver_dob;
        } else if (!finalPayload.dob) {
          finalPayload.dob = -1;
        }

        console.log("Finalizing Account with payload:", finalPayload);

        // 3. Call Account Setup
        const setupResponse = await fetch(
          `${API_DOMAIN}/telematics/service/dashboard/user/account-setup`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(finalPayload),
          },
        );
        const setupData = await setupResponse.json();
        console.log("Setup Response:", setupData);

        // 4. Handle Response
        if (
          setupData?.dbResult?.success === 1 ||
          setupData?.dbResult?.success === "1"
        ) {
          // Success - Show "Payment Successful" Card
          if (signupCard) {
            const paidAmount = finalPayload.amount || "4.99";

            signupCard.innerHTML = `
               <div style="text-align: center;">
            <div class="mb-4">
              <div>
                <img
                  src="https://cdn.shopify.com/s/files/1/0931/5614/7572/files/logo-sw.svg?v=1767598866"
                  alt="Logo"
                  width="auto"
                  height="auto"
                  onerror="this.style.display='none'">
              </div>
            </div>

            <h2 class="drive-heading mb-2">30-day Trial Activated.</h2>
            <p class="text-muted mb-4">After your trial ends, you’ll be charged for the remaining days of that billing cycle, and then billed monthly going forward.</p>

            <div
              class="alert alert-primary d-inline-flex align-items-center mb-4"
              role="alert"
              style="background-color: #eff6ff; color: #3F8BFB; border: none; font-size: 12px; padding: 8px 16px; border-radius: 5px;">
              <img
                src="https://cdn.shopify.com/s/files/1/0931/5614/7572/files/mingcute_warning-line.svg?v=1767683726"
                alt="Warning"
                width="auto"
                height="auto"
                style="width: 20px; height: 20px; margin-right: 5px;">
              A receipt has been sent to your email.
            </div>

            <div class="mb-3">
              <img
                src="https://cdn.shopify.com/s/files/1/0931/5614/7572/files/success.svg?v=1768221913"
                alt="Success"
                width="auto"
                height="auto"
                style="width: 80px; height: 80px; margin-bottom: 10px;">
              <!-- Fallback if image fails -->
              <div style="display: none; width: 80px; height: 80px; background: #22c55e; border-radius: 50%; margin: 0 auto 10px; align-items: center; justify-content: center;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="white"
                  class="bi bi-check-lg"
                  viewBox="0 0 16 16">
                  <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
                </svg>
              </div>
            </div>

            <p class="mb-1" style="font-weight: 500;">Paid amount</p>
            <h3 class="mb-4" style="font-size: 24px; font-weight: bold;">$ 0</h3>

            <p class="text-muted mb-4" style="font-size: 14px;">Billing set up complete. Start using SmartWheels.</p>

            <button
              class="btn btn-primary w-100"
              style="max-width: 300px;"
              onclick="window.location.href='/'">Next</button>
          </div>
             `;

            // Clear storage
            localStorage.removeItem("userDetails");
          }
        } else {
          // Error
          let msg =
            setupData?.dbResult?.message ||
            setupData?.message ||
            "Account setup failed.";

          if (setupData?.Status === "NOT APPROVED") {
            if (setupData?.result?.ResponseMessage) {
              msg = setupData.result.ResponseMessage;
            }
          }

          throw new Error(msg);
        }
      } else {
        throw new Error("Transaction details not found or payment failed.");
      }
    } catch (err) {
      console.error("Callback Error:", err);
      if (signupCard) {
        signupCard.innerHTML = `
          <div style="text-align: center; padding: 40px;">
            <h3 class="text-danger mb-3">Error</h3>
            <p class="text-muted mb-4">${err.message}</p>
            <button class="btn btn-secondary" onclick="window.location.href='https://www.smartwheelsgps.com/pages/drive-signup'">Try Again</button>
          </div>
        `;
      }
    }
  };

  handlePaymentCallback();
  // -------------------------------------

  if (!card || !slides.length) return;

  let accountNameTouched = false;
  let statesLoaded = false;

  const fetchStates = async () => {
    if (!stateSelect || statesLoaded) return;
    try {
      const response = await fetch(
        `${API_DOMAIN}/telematics/service/dashboard/states`,
        {
          headers: {
            Countrycode: "US",
          },
        },
      );
      const result = await response.json();
      // API returns { success: "1", statesList: [...] }
      if (result?.success !== "1" && result?.success !== 1) return;
      if (!Array.isArray(result?.statesList)) return;

      stateSelect.innerHTML = "";
      const placeholder = new Option("Select State", "");
      stateSelect.add(placeholder);

      result.statesList.forEach((st) => {
        const opt = new Option(st.statename, st.statecode);
        stateSelect.add(opt);
      });
      statesLoaded = true;
    } catch {}
  };

  const updateStep = (stepNumber) => {
    card.setAttribute("data-active-step", stepNumber);
    if (stepNumber > 1) {
      card.classList.add("is-expanded");
    } else {
      card.classList.remove("is-expanded");
    }
    slides.forEach((slide, index) => {
      const isActive = index + 1 === stepNumber;
      slide.setAttribute("aria-hidden", !isActive);
    });
    if (stepNumber === 2) {
      fetchStates();
    }
  };

  if (accountNameInput) {
    accountNameInput.addEventListener("input", () => {
      accountNameTouched = true;
    });
  }

  const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;
  let isPasswordValid = false;
  let isConfirmPasswordValid = false;
  let emailValid = false;

  const validatePassword = () => {
    if (!passwordInput || !passwordError) return;
    const password = passwordInput.value;
    if (!password) {
      passwordError.textContent = "";
      isPasswordValid = false;
      return;
    }
    if (!passwordRegex.test(password)) {
      passwordError.textContent =
        "Password must be at least 8 characters and include a number and a special character.";
      passwordError.className = "password-msg error";
      isPasswordValid = false;
    } else {
      passwordError.textContent = "Valid password";
      passwordError.className = "password-msg success";
      isPasswordValid = true;
    }
  };

  const validateConfirmPassword = () => {
    if (!confirmPasswordInput || !confirmPasswordError || !passwordInput)
      return;
    if (!confirmPasswordInput.value) {
      confirmPasswordError.textContent = "";
      isConfirmPasswordValid = false;
      return;
    }
    if (confirmPasswordInput.value !== passwordInput.value) {
      confirmPasswordError.textContent = "Passwords do not match.";
      confirmPasswordError.className = "password-msg error";
      isConfirmPasswordValid = false;
    } else {
      confirmPasswordError.textContent = "Passwords match.";
      confirmPasswordError.className = "password-msg success";
      isConfirmPasswordValid = true;
    }
  };

  const updateFinalSubmitButtonState = () => {
    if (!finalSubmitBtn) return;

    const isFirstNameValid =
      driverFirstName && driverFirstName.value.trim() !== "";
    const isLastNameValid =
      driverLastName && driverLastName.value.trim() !== "";

    // DOB Validation (Simple check, max attribute handles age restriction)
    const isDobValid = driverDob && driverDob.value !== "";
    const dobMsg = document.getElementById("driverDobMsg");
    if (dobMsg) dobMsg.textContent = "";

    const isGenderValid = driverGender && driverGender.value !== "";

    const isDriverPasswordValid =
      driverPasswordError && driverPasswordError.classList.contains("success");
    const isDriverConfirmPasswordValid =
      driverConfirmPasswordError &&
      driverConfirmPasswordError.classList.contains("success");

    const emailRequired = ownerDriverToggle && !ownerDriverToggle.checked;
    const isDriverEmailValid =
      !emailRequired ||
      (driverEmailInput &&
        driverEmailInput.value.trim() !== "" &&
        validateEmailFormat(driverEmailInput.value.trim()));

    finalSubmitBtn.disabled = !(
      isFirstNameValid &&
      isLastNameValid &&
      isDobValid &&
      isGenderValid &&
      isDriverPasswordValid &&
      isDriverConfirmPasswordValid &&
      isDriverEmailValid
    );
  };

  const validateDriverPassword = () => {
    if (!driverPasswordInput || !driverPasswordError) return;
    const password = driverPasswordInput.value;
    if (!password) {
      driverPasswordError.textContent = "";
      driverPasswordError.className = "password-msg"; // Reset class
      updateFinalSubmitButtonState();
      return;
    }
    if (!passwordRegex.test(password)) {
      driverPasswordError.textContent =
        "Password must be at least 8 characters and include a number and a special character.";
      driverPasswordError.className = "password-msg error";
    } else {
      driverPasswordError.textContent = "Strong password";
      driverPasswordError.className = "password-msg success";
    }
    updateFinalSubmitButtonState();
  };

  const validateDriverConfirmPassword = () => {
    if (
      !driverConfirmPasswordInput ||
      !driverConfirmPasswordError ||
      !driverPasswordInput
    )
      return;
    if (!driverConfirmPasswordInput.value) {
      driverConfirmPasswordError.textContent = "";
      driverConfirmPasswordError.className = "password-msg"; // Reset class
      updateFinalSubmitButtonState();
      return;
    }
    if (driverConfirmPasswordInput.value !== driverPasswordInput.value) {
      driverConfirmPasswordError.textContent = "Passwords do not match.";
      driverConfirmPasswordError.className = "password-msg error";
    } else {
      driverConfirmPasswordError.textContent = "Passwords match.";
      driverConfirmPasswordError.className = "password-msg success";
    }
    updateFinalSubmitButtonState();
  };

  const populateAccountName = () => {
    if (!accountNameInput || accountNameTouched) return;
    const firstName = firstNameInput ? firstNameInput.value.trim() : "";
    const lastName = lastNameInput ? lastNameInput.value.trim() : "";
    if (firstName || lastName) {
      accountNameInput.value = `${firstName} ${lastName}`.trim();
    }
  };

  const syncDriverDetails = () => {
    if (
      !ownerDriverToggle ||
      !emailField ||
      !driverFirstName ||
      !driverLastName
    )
      return;
    if (ownerDriverToggle.checked) {
      driverFirstName.value = firstNameInput ? firstNameInput.value.trim() : "";
      driverLastName.value = lastNameInput ? lastNameInput.value.trim() : "";

      if (passwordInput && driverPasswordInput) {
        driverPasswordInput.value = passwordInput.value;
        validateDriverPassword();
      }
      if (confirmPasswordInput && driverConfirmPasswordInput) {
        driverConfirmPasswordInput.value = confirmPasswordInput.value;
        validateDriverConfirmPassword();
      }

      emailField.style.display = "none";
    } else {
      driverFirstName.value = "";
      driverLastName.value = "";

      if (driverPasswordInput) {
        driverPasswordInput.value = "";
        validateDriverPassword();
      }
      if (driverConfirmPasswordInput) {
        driverConfirmPasswordInput.value = "";
        validateDriverConfirmPassword();
      }

      emailField.style.display = "block";
    }
    updateFinalSubmitButtonState();
  };

  if (createAccountBtn) {
    createAccountBtn.addEventListener("click", () => {
      populateAccountName();
      updateStep(2);
    });
  }

  if (prevStepBtn) {
    prevStepBtn.addEventListener("click", () => updateStep(1));
  }

  if (nextStep2Btn) {
    nextStep2Btn.addEventListener("click", () => {
      updateStep(3);
      syncDriverDetails();
    });
  }

  if (prevStep3Btn) {
    prevStep3Btn.addEventListener("click", () => updateStep(2));
  }

  syncDriverDetails();

  if (ownerDriverToggle) {
    ownerDriverToggle.addEventListener("change", syncDriverDetails);
  }

  if (firstNameInput) {
    firstNameInput.addEventListener("input", () => {
      if (ownerDriverToggle && ownerDriverToggle.checked) {
        syncDriverDetails();
      }
    });
  }

  if (lastNameInput) {
    lastNameInput.addEventListener("input", () => {
      if (ownerDriverToggle && ownerDriverToggle.checked) {
        syncDriverDetails();
      }
    });
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".password-toggle-btn");
    if (!btn) return;
    const container = btn.closest(".password-field-container");
    if (!container) return;
    const input = container.querySelector(".password-input");
    const showIcon = btn.querySelector(".show-icon");
    const hideIcon = btn.querySelector(".hide-icon");
    if (!input || !showIcon || !hideIcon) return;
    if (input.type === "password") {
      input.type = "text";
      showIcon.classList.add("is-hidden");
      hideIcon.classList.remove("is-hidden");
    } else {
      input.type = "password";
      showIcon.classList.remove("is-hidden");
      hideIcon.classList.add("is-hidden");
    }
  });

  const updateCreateButtonState = () => {
    if (!createAccountBtn) return;
    const isAgreeChecked = agreeCheckbox ? agreeCheckbox.checked : false;
    createAccountBtn.disabled = !(
      isPasswordValid &&
      isConfirmPasswordValid &&
      emailValid &&
      isAgreeChecked
    );
  };

  if (passwordInput) {
    passwordInput.addEventListener("input", () => {
      validatePassword();
      validateConfirmPassword();
      updateCreateButtonState();
      if (ownerDriverToggle && ownerDriverToggle.checked) {
        syncDriverDetails();
      }
    });
  }

  if (confirmPasswordInput) {
    confirmPasswordInput.addEventListener("input", () => {
      validateConfirmPassword();
      updateCreateButtonState();
      if (ownerDriverToggle && ownerDriverToggle.checked) {
        syncDriverDetails();
      }
    });
  }

  if (agreeCheckbox) {
    agreeCheckbox.addEventListener("change", updateCreateButtonState);
  }

  if (driverPasswordInput) {
    driverPasswordInput.addEventListener("input", () => {
      validateDriverPassword();
      validateDriverConfirmPassword();
    });
  }

  if (driverConfirmPasswordInput) {
    driverConfirmPasswordInput.addEventListener("input", () => {
      validateDriverConfirmPassword();
    });
  }

  // Add listeners for other Step 3 fields to update button state
  if (driverFirstName) {
    driverFirstName.addEventListener("input", updateFinalSubmitButtonState);
  }
  if (driverLastName) {
    driverLastName.addEventListener("input", updateFinalSubmitButtonState);
  }
  if (driverDob) {
    driverDob.addEventListener("input", updateFinalSubmitButtonState);
    driverDob.addEventListener("change", updateFinalSubmitButtonState);
  }
  if (driverGender) {
    driverGender.addEventListener("change", updateFinalSubmitButtonState);
  }
  if (driverEmailInput) {
    driverEmailInput.addEventListener("input", updateFinalSubmitButtonState);
    driverEmailInput.addEventListener("blur", () => {
      const email = driverEmailInput.value.trim();
      if (!driverEmailMsg) return;
      if (!email) {
        driverEmailMsg.textContent = "";
        updateFinalSubmitButtonState();
        return;
      }
      if (!validateEmailFormat(email)) {
        driverEmailMsg.textContent = "Please enter a valid email address.";
        driverEmailMsg.className = "email-validation-msg error";
        updateFinalSubmitButtonState();
        return;
      }
      // Assuming verifyEmail is only for signupEmail or if we want to verify driver email too.
      // For now, let's just do format validation as per request.
      driverEmailMsg.textContent = "";
      driverEmailMsg.className = "email-validation-msg";
      updateFinalSubmitButtonState();
    });
  }

  function validateEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  const verifyEmail = async (email) => {
    if (!emailMsg || !createAccountBtn) return;
    emailMsg.textContent = "Validating email...";
    emailMsg.className = "email-validation-msg";
    emailValid = false;
    updateCreateButtonState();
    try {
      const response = await fetch(
        `${API_DOMAIN}/telematics/service/dashboard/user/verify-email?email=${encodeURIComponent(
          email,
        )}`,
      );
      const result = await response.json();
      const data = result?.Data?.[0];
      if (data?.level === "Success") {
        emailValid = true;
        emailMsg.textContent = data.message;
        emailMsg.classList.add("success");
      } else {
        emailValid = false;
        emailMsg.textContent = data?.message || "Email validation failed.";
        emailMsg.classList.add("error");
      }
    } catch {
      emailValid = false;
      emailMsg.textContent = "Unable to validate email. Please try again.";
      emailMsg.classList.add("error");
    }
    updateCreateButtonState();
  };

  if (emailInput) {
    emailInput.addEventListener("blur", () => {
      const email = emailInput.value.trim();
      if (!emailMsg) return;
      if (!email) {
        emailMsg.textContent = "";
        emailValid = false;
        updateCreateButtonState();
        return;
      }
      if (!validateEmailFormat(email)) {
        emailMsg.textContent = "Please enter a valid email address.";
        emailMsg.className = "email-validation-msg error";
        emailValid = false;
        updateCreateButtonState();
        return;
      }
      verifyEmail(email);
    });
  }

  const fetchZipDetails = async (zipcode) => {
    try {
      const response = await fetch(
        `${API_DOMAIN}/telematics/service/dashboard/zipcode-detail?zipcode=${encodeURIComponent(
          zipcode,
        )}`,
      );
      const result = await response.json();
      if (result?.success !== 1 || !result?.detail?.address) return;
      const address = result.detail.address;
      const countyVal =
        address.county ||
        address.county_name ||
        address.County ||
        address.CountyName;
      if (countyInput && countyVal) {
        countyInput.value = String(countyVal);
      }
    } catch {}
  };

  // Removed state/country selection logic from ZIP API per requirements

  if (zipInput) {
    zipInput.addEventListener("blur", () => {
      const zipcode = zipInput.value.trim();
      if (!zipcode) return;
      if (!/^\d{5,6}$/.test(zipcode)) return;
      fetchZipDetails(zipcode);
    });
  }

  const fetchReferralSources = async () => {
    if (!referralSelect) {
      console.warn("referralSelect not found, skipping fetch.");
      return;
    }
    try {
      console.log("Fetching referral sources...");
      const response = await fetch(
        `${API_DOMAIN}/telematics/service/dashboard/user/masterData?type=referral`,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      const list = result?.masterData;
      const amountList = result?.amount;
      const priceValue = Array.isArray(amountList) && amountList[0]?.value;

      if (priceValue) {
        defaultSubscriptionPrice = `$ ${priceValue}`;
        updateSubscriptionPrice(defaultSubscriptionPrice);
      }

      if (!Array.isArray(list) || !list.length) return;
      const placeholderText =
        referralSelect.options[0]?.text || "How did you hear about us?";
      referralSelect.innerHTML = "";
      const placeholderOption = new Option(placeholderText, "");
      referralSelect.add(placeholderOption);
      list.forEach((item) => {
        const opt = new Option(item.referral_source, String(item.id));
        if (item.is_referral_code_validate !== undefined) {
          opt.setAttribute(
            "data-validate-promo",
            String(item.is_referral_code_validate),
          );
        }
        if (item.is_partner_code_validate !== undefined) {
          opt.setAttribute(
            "data-validate-partner",
            String(item.is_partner_code_validate),
          );
        }
        referralSelect.add(opt);
      });
    } catch (error) {
      console.error("Error fetching referral sources:", error);
    }
  };

  fetchReferralSources();

  const ensureDefaultCountryUS = () => {
    if (!countrySelect) return;
    const desiredText = "United States";
    const desiredValue = "United States";
    const exists = [...countrySelect.options].some(
      (opt) =>
        opt.text.trim().toLowerCase() === desiredText.toLowerCase() ||
        opt.value.trim().toLowerCase() === desiredValue.toLowerCase(),
    );
    if (!exists) {
      const opt = new Option(desiredText, desiredValue);
      countrySelect.add(opt);
    }
    countrySelect.value = desiredValue;
  };

  ensureDefaultCountryUS();

  // Step-2 Next button enable/disable based on mandatory fields + checkbox
  const updateStep2ButtonState = () => {
    if (!nextStep2Btn) return;
    const isAccountNameValid =
      accountNameInput && accountNameInput.value.trim() !== "";
    const isReferralValid = referralSelect && !!referralSelect.value;
    const phoneEl = document.getElementById("phoneNumber");
    const phoneVal = phoneEl ? phoneEl.value.trim() : "";
    const isPhoneValid =
      phoneVal !== "" && /^[0-9+]+$/.test(phoneVal) && phoneVal.length <= 15;
    const isStreetValid =
      document.getElementById("streetAddress") &&
      document.getElementById("streetAddress").value.trim() !== "";
    const isCityValid =
      document.getElementById("cityInput") &&
      document.getElementById("cityInput").value.trim() !== "";
    const isStateValid = stateSelect && stateSelect.value.trim() !== "";
    const isCountryValid = countrySelect && countrySelect.value.trim() !== "";
    const zipVal = zipInput ? zipInput.value.trim() : "";
    const isZipValid = /^\d{5,6}$/.test(zipVal);
    const isAgreeChecked = step2AgreeCheckbox && step2AgreeCheckbox.checked;

    nextStep2Btn.disabled = !(
      isAccountNameValid &&
      // isReferralValid &&
      isPhoneValid &&
      isStreetValid &&
      isCityValid &&
      isStateValid &&
      isCountryValid &&
      isZipValid &&
      isAgreeChecked
    );
  };

  // Initialize disabled states
  if (nextStep2Btn) nextStep2Btn.disabled = true;
  if (finalSubmitBtn) finalSubmitBtn.disabled = true;
  updateStep2ButtonState();
  updateFinalSubmitButtonState();

  // Step-2 listeners
  if (accountNameInput)
    accountNameInput.addEventListener("input", updateStep2ButtonState);
  if (referralSelect)
    referralSelect.addEventListener("change", updateStep2ButtonState);
  const phoneInput = document.getElementById("phoneNumber");
  const phoneNumberMsg = document.getElementById("phoneNumberMsg");
  if (phoneInput) {
    phoneInput.addEventListener("input", (e) => {
      let val = e.target.value;
      const originalVal = val;

      // Allow only numbers and +
      val = val.replace(/[^0-9+]/g, "");

      // Limit to 15 characters
      if (val.length > 15) {
        val = val.slice(0, 15);
      }

      if (originalVal !== val) {
        e.target.value = val;
        if (phoneNumberMsg) {
          phoneNumberMsg.textContent =
            "Enter a Valid Phone Number (e.g., +12345678901)";
          phoneNumberMsg.className = "small mt-1 text-danger";
        }
      } else {
        if (phoneNumberMsg) phoneNumberMsg.textContent = "";
      }
      updateStep2ButtonState();
    });
  }
  const streetInput = document.getElementById("streetAddress");
  if (streetInput)
    streetInput.addEventListener("input", updateStep2ButtonState);
  const cityInput = document.getElementById("cityInput");
  if (cityInput) cityInput.addEventListener("input", updateStep2ButtonState);
  if (stateSelect)
    stateSelect.addEventListener("change", updateStep2ButtonState);
  if (countrySelect)
    countrySelect.addEventListener("change", updateStep2ButtonState);
  if (zipInput) {
    zipInput.addEventListener("input", updateStep2ButtonState);
    zipInput.addEventListener("blur", updateStep2ButtonState);
  }
  if (step2AgreeCheckbox)
    step2AgreeCheckbox.addEventListener("change", updateStep2ButtonState);

  // Promo Code Implementation
  const promoCodeInput = document.getElementById("promoCodeInput");
  const applyPromoBtn = document.getElementById("applyPromoBtn");
  const promoMessage = document.getElementById("promoMessage");

  if (applyPromoBtn && promoCodeInput && promoMessage) {
    promoCodeInput.addEventListener("input", () => {
      applyPromoBtn.disabled = !promoCodeInput.value.trim();
    });

    applyPromoBtn.addEventListener("click", async () => {
      const promoCode = promoCodeInput.value.trim();
      if (!promoCode) {
        promoMessage.textContent = "Please enter a promo code.";
        promoMessage.className = "small mt-1 text-danger";
        return;
      }

      // Gather Parameters
      const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
      let referalId = "1"; // Default
      let isPartner = "0";

      if (referralSelect && referralSelect.value) {
        referalId = referralSelect.value;
        const selectedOption =
          referralSelect.options[referralSelect.selectedIndex];
        // Check if selected option is "Xemplar Partner"
        if (selectedOption.text === "Xemplar Partner") {
          isPartner = "1";
        }
      }

      promoMessage.textContent = "Validating...";
      promoMessage.className = "small mt-1 text-muted";
      applyPromoBtn.disabled = true;

      try {
        const url = `${API_DOMAIN}/telematics/service/dashboard/user/validate-promo-code?promo_code=${encodeURIComponent(
          promoCode,
        )}&current_date=${today}&isPartner=${isPartner}&orgId=0&referalId=${referalId}`;

        const response = await fetch(url);
        const result = await response.json();

        if (result?.success === 1 || result?.success === "1") {
          promoMessage.textContent = result.message || "Promo code applied!";
          promoMessage.className = "small mt-1 text-success";
          if (Array.isArray(result?.data) && result.data[0]?.final_fee) {
            updateSubscriptionPrice(`$ ${result.data[0].final_fee}`);
          }
        } else {
          promoMessage.textContent = result?.message || "Invalid promo code.";
          promoMessage.className = "small mt-1 text-danger";
          if (defaultSubscriptionPrice) {
            updateSubscriptionPrice(defaultSubscriptionPrice);
          }
        }
      } catch (error) {
        promoMessage.textContent = "Error validating promo code.";
        promoMessage.className = "small mt-1 text-danger";
        if (defaultSubscriptionPrice) {
          updateSubscriptionPrice(defaultSubscriptionPrice);
        }
      } finally {
        applyPromoBtn.disabled = false;
        applyPromoBtn.textContent = "Apply promo";
      }
    });
  }

  // Partner ID and Referral Logic
  const partnerDetails = document.getElementById("partnerDetails");
  const referralInfoDetails = document.getElementById("referralInfoDetails");
  const partnerIdInput = document.getElementById("partnerIdInput");
  const partnerNameInput = document.getElementById("partnerNameInput");
  const partnerIdMsg = document.getElementById("partnerIdMsg");
  const referralInfoInput = document.getElementById("referralInfoInput");

  if (referralSelect) {
    referralSelect.addEventListener("change", () => {
      const selectedOption =
        referralSelect.options[referralSelect.selectedIndex];
      const selectedText = selectedOption.text;
      const shouldValidatePromo = selectedOption.getAttribute(
        "data-validate-promo",
      );
      const shouldValidatePartner = selectedOption.getAttribute(
        "data-validate-partner",
      );

      // Promo code toggle logic
      if (promoCodeInput && applyPromoBtn) {
        // Clear fields on change
        promoCodeInput.value = "";
        applyPromoBtn.disabled = true;
        if (promoMessage) promoMessage.textContent = "";

        if (shouldValidatePromo === "0") {
          promoCodeInput.disabled = true;
        } else {
          promoCodeInput.disabled = false;
        }
      }

      const isPartner = shouldValidatePartner === "1";
      const isOther = selectedText === "Other";

      // Clear partner fields when referral source changes
      if (partnerIdInput) partnerIdInput.value = "";
      if (partnerNameInput) partnerNameInput.value = "";
      if (partnerIdMsg) partnerIdMsg.textContent = "";
      if (defaultSubscriptionPrice) {
        updateSubscriptionPrice(defaultSubscriptionPrice);
      }

      if (partnerDetails) {
        partnerDetails.style.display = isPartner ? "block" : "none";
      }
      if (referralInfoDetails) {
        referralInfoDetails.style.display = isOther ? "block" : "none";
      }
    });
  }

  if (partnerIdInput && partnerNameInput) {
    partnerIdInput.addEventListener("blur", async () => {
      const partnerId = partnerIdInput.value.trim();
      if (!partnerId) {
        partnerNameInput.value = "";
        if (partnerIdMsg) partnerIdMsg.textContent = "";
        if (defaultSubscriptionPrice) {
          updateSubscriptionPrice(defaultSubscriptionPrice);
        }
        return;
      }

      if (partnerIdMsg) {
        partnerIdMsg.textContent = "Validating...";
        partnerIdMsg.className = "small mt-1 text-muted";
      }

      try {
        const today = new Date().toISOString().split("T")[0];
        const currentReferralId = referralSelect ? referralSelect.value : "8";
        const response = await fetch(
          `${API_DOMAIN}/telematics/service/dashboard/user/validate-promo-code?promo_code=${encodeURIComponent(
            partnerId,
          )}&current_date=${today}&isPartner=1&orgId=0&referalId=${currentReferralId}`,
        );
        const result = await response.json();

        // API returns success: 2 for partner code validation based on web ref
        if (
          (result?.success === 1 ||
            result?.success === 2 ||
            result?.success === "1" ||
            result?.success === "2") &&
          Array.isArray(result?.data) &&
          result.data[0]
        ) {
          partnerNameInput.value = result.data[0].partner_name || "";
          if (result.data[0].final_fee) {
            updateSubscriptionPrice(`$ ${result.data[0].final_fee}`);
          }
          if (partnerIdMsg) {
            partnerIdMsg.textContent =
              result.message || "Partner code validated successfully.";
            partnerIdMsg.className = "small mt-1 text-success";
          }
        } else {
          partnerNameInput.value = "";
          if (defaultSubscriptionPrice) {
            updateSubscriptionPrice(defaultSubscriptionPrice);
          }
          if (partnerIdMsg) {
            partnerIdMsg.textContent = result?.message || "Invalid Partner ID.";
            partnerIdMsg.className = "small mt-1 text-danger";
          }
        }
      } catch (error) {
        partnerNameInput.value = "";
        if (defaultSubscriptionPrice) {
          updateSubscriptionPrice(defaultSubscriptionPrice);
        }
        if (partnerIdMsg) {
          partnerIdMsg.textContent = "Error validating Partner ID.";
          partnerIdMsg.className = "small mt-1 text-danger";
        }
      }
    });
  }

  if (driverFirstName) {
    driverFirstName.addEventListener("input", updateFinalSubmitButtonState);
  }
  if (driverLastName) {
    driverLastName.addEventListener("input", updateFinalSubmitButtonState);
  }
  if (driverDob) {
    driverDob.addEventListener("input", updateFinalSubmitButtonState);
  }
  if (driverGender) {
    driverGender.addEventListener("change", updateFinalSubmitButtonState);
  }

  if (finalSubmitBtn) {
    finalSubmitBtn.addEventListener("click", () => {
      const modalEl = document.getElementById("billingConfirmationModal");
      if (modalEl && window.bootstrap) {
        const modal = new bootstrap.Modal(modalEl, { backdrop: true });
        modal.show();
      }
    });
  }
// final amount function
function calculateProratedAmount(monthlyFee, billingStartDate) {

  const date = new Date(billingStartDate);
  const y = date.getFullYear();
  const m = date.getMonth();

  const lastDay = new Date(y, m + 1, 0);
  const currentDate = new Date(billingStartDate);

  const isPM = currentDate.getHours() >= 12;

  let numberOfBillingDays;

  if (isPM) {
    numberOfBillingDays =
      Math.round((lastDay - currentDate) / (1000 * 60 * 60 * 24)) + 2;
  } else {
    numberOfBillingDays =
      Math.round((lastDay - currentDate) / (1000 * 60 * 60 * 24)) + 1;
  }

  const daysInMonth = new Date(y, m + 1, 0).getDate();

  let chargeAmount = (monthlyFee * numberOfBillingDays) / daysInMonth;

  return chargeAmount.toFixed(2);
}
  if (confirmBillingBtn) {
    confirmBillingBtn.addEventListener("click", async () => {
      // Helper to get value safely
      const getVal = (id) => {
        const el = document.getElementById(id);
        return el ? el.value.trim() : "";
      };

      const getSelectText = (id) => {
        const el = document.getElementById(id);
        if (el && el.selectedIndex >= 0) {
          return el.options[el.selectedIndex].text;
        }
        return "";
      };

      // Gather Data
      const now = new Date();
      const isoDate = now.toISOString();

    
  var freeTrailDays = 30;

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

  var billingStartDate = addDays(new Date(), freeTrailDays);

  var billing_start_date = formatDate(billingStartDate);

  // var billing_start_date = moment(billingStartDate).format('YYYY-MM-DD');

      let subAmount = "8.95";
      // const priceEl = document.getElementById("subscriptionPrice");
      // if (priceEl && priceEl.textContent) {
      //   const match = priceEl.textContent.match(/[\d\.]+/);
      //   if (match) subAmount = match[0];
      // }

      let monthlyFee = 8.95;

const priceEl = document.getElementById("subscriptionPrice");

if (priceEl && priceEl.textContent) {
  const match = priceEl.textContent.match(/[\d\.]+/);
  if (match) monthlyFee = parseFloat(match[0]);
}

// ⭐prorated amount calculation
const proratedAmount = calculateProratedAmount(monthlyFee, billingStartDate);

// let subAmount = proratedAmount;

      const isOwnerDriver = ownerDriverToggle
        ? ownerDriverToggle.checked
        : false;
      const drvFirstName = getVal("driverFirstName");
      const drvLastName = getVal("driverLastName");
      let drvEmail = "";

      if (isOwnerDriver) {
        drvEmail = getVal("signupEmail");
      } else {
        drvEmail = getVal("driverEmailInput");
      }

      const stateName = getSelectText("stateSelect");
      const stateCode = getVal("stateSelect");
      const refSource = getVal("referralSourceSelect");

      const payload = {
        prefix: "",
        first_name: getVal("firstName"),
        last_name: getVal("lastName"),
        suffix: "",
        email_id: getVal("signupEmail"),
        password: getVal("password"),
        account_name: getVal("accountName"),
        account_contact_number: getVal("phoneNumber"),
        referral_source: refSource ? parseInt(refSource) : 1,
        partner_id: getVal("partnerIdInput"),
        address: getVal("streetAddress"),
        city: getVal("cityInput"),
        state: stateName,
        country: "United States",
        postal_code: getVal("zipCode"),
        county: getVal("county"),
        setup_datetime: isoDate,
        agreement_id: "",
        promocode_id: getVal("promoCodeInput"),
        notes: "",
        amount: proratedAmount,
        subscription_amount: subAmount,
        free_trial_days: freeTrailDays,
        billing_start_date: billing_start_date,
        driver_first_name: drvFirstName,
        driver_last_name: drvLastName,
        driver_email_id: drvEmail,
        driver_password: getVal("driverPassword"),
        driver_dob: getVal("driverDob"),
        driver_gender: getVal("driverGender"),
        isOwnerDriver: isOwnerDriver,
        cardHolderName: "",
        cardNumber: "",
        month: "",
        year: "",
        cvv: "",
        billing_address: getVal("streetAddress"),
        billing_city: getVal("cityInput"),
        billing_state: stateCode,
        billing_country: "United States",
        billing_zipcode: getVal("zipCode"),
        billing_county: getVal("county"),
        expiryDate: "",
        transactAmount: proratedAmount,
        isDiscountApplied: getVal("promoCodeInput") ? 1 : 0,
      };

      console.log("Sending payload:", payload);

      // Show loading state?
      const originalText = confirmBillingBtn.textContent;
      confirmBillingBtn.textContent = "Processing...";
      confirmBillingBtn.disabled = true;

      try {
        const response = await fetch(
          `${API_DOMAIN}/telematics/service/dashboard/add-customer/form-link`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );
        const result = await response.json();
        console.log("API Result:", result);

        if (result?.success === 1 || result?.success === "1") {
          // Success
          const modalEl = document.getElementById("billingConfirmationModal");
          if (modalEl && window.bootstrap) {
            const modal = bootstrap.Modal.getInstance(modalEl);
            if (modal) modal.hide();
          }

          // Store payload for callback handling (matches legacy accountSetUp.html behavior)
          localStorage.setItem("userDetails", JSON.stringify(payload));

          if (result.link) {
            // Redirect to payment gateway
            window.location.href = result.link.trim();
          } else {
            console.error("Payment link missing in response", result);
            alert("Error: Payment link missing.");
          }
        } else {
          alert(
            "Failed to create account: " + (result.message || "Unknown error"),
          );
        }
      } catch (error) {
        console.error("Error creating account:", error);
        alert("An error occurred while creating the account.");
      } finally {
        confirmBillingBtn.textContent = originalText;
        confirmBillingBtn.disabled = false;
      }
    });
  }
});
